import React from 'react'
import { Form, Modal } from 'react-bootstrap'
import { ReactComponent as DeleteImg } from '../../assets/images/redbin.svg'
import { ReactComponent as LogoutImg } from '../../assets/images/logout.svg'
import ButtonWithLoader from '../ButtonWithLoader/ButtonWithLoader'
import { ReactComponent as LogoutAdmin } from '../../assets/images/adminLogout.svg'
const DeleteModal = ({
    title = 'CV',
    handleDelete,
    setIsDeleteModal,
    isDeleteModal,
    isLoading,
    isLogout,
    message = (
        <>
            Are you sure you want to delete this job <br />
            application?
        </>
    )
}) => {
    return (
        <Modal
            className="modalbox deletemodal"
            show={isDeleteModal}
            onHide={() => setIsDeleteModal(false)}
            backdrop="static"
            keyboard={false}
            centered
        >
            {/* {!isLogout && <Modal.Header closeButton>Delete {title}</Modal.Header>} */}

            <Modal.Body>
                <Form className="formbox">
                    <div className="delete-box">
                        {/* <div className="deleteimg">{isLogout ? <LogoutAdmin /> : <DeleteImg />}</div> */}
                        <div className="deleteimg">
                            <LogoutAdmin />
                        </div>
                        <div className="content">
                            <h4>{message}</h4>
                        </div>
                        <div className="delete-action">
                            <ButtonWithLoader
                                isLoading={isLoading}
                                cssClass="common-btn yes"
                            >
                                <button
                                    className="common-btn yes"
                                    type="button"
                                    onClick={handleDelete}
                                >
                                    Yes
                                </button>
                            </ButtonWithLoader>
                            <button
                                disabled={isLoading}
                                type="button"
                                className="common-btn no"
                                onClick={() => {
                                    setIsDeleteModal(false)
                                }}
                            >
                                No
                            </button>
                        </div>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default React.memo(DeleteModal)
